import React, { useEffect, useState } from 'react'
import Icon from '../components/Icons'

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const toggle = () => setVisible(window.scrollY > 700)
    toggle()
    window.addEventListener('scroll', toggle, { passive: true })
    return () => window.removeEventListener('scroll', toggle)
  }, [])

  return (
    <button
      type="button"
      aria-label="Back to top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className={`group fixed bottom-8 right-6 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-ink-950 text-paper-100 transition-all duration-500 ease-out-expo hover:bg-accent-500 md:right-10 ${
        visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
      }`}
    >
      <Icon
        name="arrow"
        className="h-4 w-4 -rotate-90 transition-transform duration-500 ease-out-expo group-hover:-translate-y-0.5"
      />
    </button>
  )
}

export default ScrollToTop
